import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SideNavigationService } from '@sb-tools/typescript/services/side-navigation.service';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { CommunityUserExtended } from '@sb-tools/typescript/models/community-user-extended.model';
import { CommonDataForSettingsService } from '@core/services/common-data-for-settings.service';
import { BreadcrumbService } from '@core/services/breadcrumb.service';
import { Breadcrumb } from '@shared/models/breadcrumb.model';
import { SettingsMenuComponent } from '@sb-settings-menu/settings-menu.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.scss'],
    imports: [SettingsMenuComponent, TranslatePipe, NgClass, BreadcrumbComponent],
})
export class TopMenuComponent implements OnInit, OnDestroy {
    communityUser: CommunityUserExtended;
    title: string;

    private unsubscriber = new Subject<void>();

    constructor(
        public authenticationService: AuthenticationService,
        public commonDataService: CommonDataService,
        public commonDataForSettingsService: CommonDataForSettingsService,
        public sideNavigationService: SideNavigationService,
        private activatedRoute: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
        private router: Router,
    ) {
        this.router.events
            .pipe(
                filter((event) => {
                    return event instanceof NavigationEnd;
                }),
                map(() => {
                    let route = this.activatedRoute.firstChild;
                    let child = route;
                    while (child) {
                        if (child.firstChild) {
                            child = child.firstChild;
                            route = child;
                        } else {
                            child = null;
                        }
                    }
                    return route;
                }),
                mergeMap((route) => {
                    return route.data;
                }),
            )
            .subscribe((data) => {
                this.title = data.breadcrumb?.label;
            });

        this.breadcrumbService.updatedLabel$.pipe(takeUntil(this.unsubscriber)).subscribe(() => {
            const breadcrumb = this.getLastBreadcrumb(this.activatedRoute);
            this.title = breadcrumb?.label;
        });
    }

    ngOnInit() {
        this.communityUser = this.commonDataService.user;
    }

    private getLastBreadcrumb(route: ActivatedRoute): Breadcrumb {
        if (route.firstChild) {
            return this.getLastBreadcrumb(route.firstChild);
        }
        return route.routeConfig.data?.breadcrumb;
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
